import { api } from "@/lib/api";

export const listPartnerBrands = () => api.get("/partner-brands").then((r) => r.data);
export const adminListPartnerBrands = (includeInactive = true) =>
    api.get(`/admin/partner-brands?include_inactive=${includeInactive}`).then((r) => r.data);
export const adminCreatePartnerBrand = (body) => api.post("/admin/partner-brands", body).then((r) => r.data);
export const adminUpdatePartnerBrand = (id, body) => api.patch(`/admin/partner-brands/${id}`, body).then((r) => r.data);
export const adminDeactivatePartnerBrand = (id) => api.delete(`/admin/partner-brands/${id}`).then((r) => r.data);

export const getPartnerClicksReport = (params = {}) => {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => v && q.set(k, v));
    return api.get(`/admin/reports/partner-clicks?${q}`).then((r) => r.data);
};

/** Fire the PARTNER_LINK engagement event. Fire-and-forget: we log but never block. */
export const trackPartnerClick = async (postId) => {
    try {
        await api.post(`/posts/${postId}/track`, {
            event_type: "ENGAGEMENT",
            engagement_type: "PARTNER_LINK",
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("PARTNER_LINK track failed", e);
    }
};

/** Extract YouTube video id from any accepted URL, else null. */
export const extractYouTubeVideoId = (url) => {
    if (!url) return null;
    const re = /^https?:\/\/(?:www\.|m\.)?(?:youtube\.com\/(?:watch\?(?:.*&)?v=|shorts\/|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/i;
    const m = String(url).trim().match(re);
    return m ? m[1] : null;
};

/** Map partner brand slug → CTA action verb by post type. */
const ACTION_MAP = {
    amazon: "Shop", flipkart: "Shop", myntra: "Shop", nykaa: "Shop", ajio: "Shop",
    zomato: "Order", swiggy: "Order",
    makemytrip: "Book", yatra: "Book",
    bookmyshow: "Book",
    paytm: "Pay on",
    justdial: "Find on",
};

export const partnerCtaLabel = (post, brand) => {
    if (post?.type === "MOVIE") {
        if (brand?.name) return `Book on ${brand.name}`;
        return "Book Tickets";
    }
    if (!brand) return "Go to Partner Site";
    const verb = ACTION_MAP[brand.slug] || "Visit";
    if (verb.endsWith(" on") || verb.endsWith(" On")) return `${verb} ${brand.name}`;
    return `${verb} on ${brand.name}`;
};

export const brandsBySlug = (brands) => Object.fromEntries((brands || []).map((b) => [b.slug, b]));
